// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post_header_profile{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid var(--border);
}


.post_table_user{
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 10px;
    align-items: center
}

.post_user_name{
    margin: 0;
    font-size: 22px;
    font-weight: bold;
}

.post_user_email{
    color: var(--text-muted);
}

.post_user_detail{
    display: flex;
    flex-direction: column;
}

.post_userInformation_profil_img{
    width: 60px;
    height: 60px;
    background-position: center;
    background-size: cover;
    border-radius: 322px;
}

.post_desc_header{
    display: flex;
    flex-direction: row;
    justify-content: end;
    gap: 10px;
    width: 100%;
}

.post_archive_button,
.post_pin_button,
.comment_delete_button,
.post_unpin_button{
    background-color: var(--primary);
    border: none;
    border-radius: 20px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
}

.post_pin_button:disabled,
.post_unpin_button:disabled{
    background-color: #7d9ef3;
}

.post_desc_container{
    margin-top: 30px;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    padding: 20px;
    border-radius: 30px;
}

.post_content{
    font-size: 1.3rem;
    font-weight: 500;
    white-space: pre-wrap;
}

.post_image{
    max-width: 100%;
    max-height: 420px;
    border-radius: 12px;
    margin-top: 15px;
    object-fit: cover;
}

.post_poll{
    margin-top: 15px;
    padding: 15px;
    border: 1px solid var(--border);
    border-radius: 12px;
    background-color: var(--bg);
}

.post_poll_question{
    font-weight: bold;
    margin: 0 0 10px 0;
}

.post_poll_options{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.post_poll_option{
    border: 1px solid var(--border);
    border-radius: 20px;
    padding: 8px 15px;
}

.post_poll_multiple_tag{
    display: inline-block;
    margin-top: 10px;
    font-size: 12px;
    color: var(--text-muted);
}

.post_footer{
    display: flex;
    align-items: end;
    justify-content: end;
    font-size: 13px;
}

.comments_container {
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: end;
}

.comment_desc_header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.comment_desc_container{
    width: 80%;
    margin-top: 30px;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    padding: 20px;
    border-radius: 30px;
}

.child_comment_desc_container{
    width: 60%;
    margin-top: 30px;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    padding: 20px;
    border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/posts/PostId/postId.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,sCAAsC;AAC1C;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT;AACJ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,WAAW;AACf;;AAEA;;;;IAII,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".post_header_profile{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border-bottom: 1px solid var(--border);\n}\n\n\n.post_table_user{\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    gap: 10px;\n    align-items: center\n}\n\n.post_user_name{\n    margin: 0;\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.post_user_email{\n    color: var(--text-muted);\n}\n\n.post_user_detail{\n    display: flex;\n    flex-direction: column;\n}\n\n.post_userInformation_profil_img{\n    width: 60px;\n    height: 60px;\n    background-position: center;\n    background-size: cover;\n    border-radius: 322px;\n}\n\n.post_desc_header{\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    gap: 10px;\n    width: 100%;\n}\n\n.post_archive_button,\n.post_pin_button,\n.comment_delete_button,\n.post_unpin_button{\n    background-color: var(--primary);\n    border: none;\n    border-radius: 20px;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: bold;\n    color: #fff;\n    cursor: pointer;\n}\n\n.post_pin_button:disabled,\n.post_unpin_button:disabled{\n    background-color: #7d9ef3;\n}\n\n.post_desc_container{\n    margin-top: 30px;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 20px;\n    border-radius: 30px;\n}\n\n.post_content{\n    font-size: 1.3rem;\n    font-weight: 500;\n    white-space: pre-wrap;\n}\n\n.post_image{\n    max-width: 100%;\n    max-height: 420px;\n    border-radius: 12px;\n    margin-top: 15px;\n    object-fit: cover;\n}\n\n.post_poll{\n    margin-top: 15px;\n    padding: 15px;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    background-color: var(--bg);\n}\n\n.post_poll_question{\n    font-weight: bold;\n    margin: 0 0 10px 0;\n}\n\n.post_poll_options{\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.post_poll_option{\n    border: 1px solid var(--border);\n    border-radius: 20px;\n    padding: 8px 15px;\n}\n\n.post_poll_multiple_tag{\n    display: inline-block;\n    margin-top: 10px;\n    font-size: 12px;\n    color: var(--text-muted);\n}\n\n.post_footer{\n    display: flex;\n    align-items: end;\n    justify-content: end;\n    font-size: 13px;\n}\n\n.comments_container {\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n    align-items: end;\n}\n\n.comment_desc_header{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.comment_desc_container{\n    width: 80%;\n    margin-top: 30px;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 20px;\n    border-radius: 30px;\n}\n\n.child_comment_desc_container{\n    width: 60%;\n    margin-top: 30px;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 20px;\n    border-radius: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
